import { Navigate, Outlet, useNavigate } from "react-router-dom"

const ProtectedRoute = () => {
    const navigate = useNavigate
    const token = localStorage.getItem('token')
    // console.log("TOKENNn",token)
    return token ? <Outlet/> : () => navigate('/login') 
}

export default ProtectedRoute